import React from 'react';
import { useTranslation } from 'next-i18next';
import ReactPlayer from 'react-player/lazy';
// import Video from '../../../organisms/Video';

const SchoolTeachersNumber = () => {
  const { t } = useTranslation('common');
  const videoId = '-2Nocv3iySM';
  // const coverUrl = `https://i.ytimg.com/vi/${videoId}/0.jpg`;
  // const videoThumbStyle = { background: `url(${coverUrl}) no-repeat` };
  const videoUrl = `https://www.youtube.com/embed/${videoId}?rel=0&amp;modestbranding=1&amp;showinfo=0&amp;autoplay=1`;
  return (
    <div className="school-section small-top-margin">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <ReactPlayer
            url={videoUrl}
            config={{
              youtube: {
                playerVars: { showinfo: 0 },
              },
            }}
          />
          <div className="mt-8">
            <h2 className="school-section-title h3">
              {t(
                'service.school.certifiedTeachers.explanations.title.americanAccent',
              )}
            </h2>
            <p className="school-section-description">
              {t(
                'service.school.certifiedTeachers.explanations.detail.americanAccent',
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolTeachersNumber;
